import * as React from 'react';
import { Field } from 'redux-form';

import * as ReduxUtils from 'af-utils/reduxForms.util';

import Input from 'af-fields/Input';

import Checkbox from 'af-components/Controls/Checkbox';

import styles from './styles.module.scss';

interface PerDiemForTs {
	perDiemFlag: boolean;
	perDiemAmount: Nullable<string>;
}

interface OwnProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	change: (field: string, value: any) => void;
	field: string;
	isEditable: boolean;
	perDiemForTS: PerDiemForTs;

}

type Props = OwnProps;

const PerDiemOnTimeSheet: React.FC<Props> = (props: Props) => {
	const { isEditable, perDiemForTS, change, field } = props;

	const changePerDiemFlag = React.useCallback(() => {
		change(`${field}.perDiemInfo.perDiemFlag`, !perDiemForTS.perDiemFlag);

		// If perDiem is currently set to true, that means we are changing it to false so we need to set amount to null
		if (!!perDiemForTS.perDiemFlag) {
			change(`${field}.perDiemInfo.perDiemAmount`, null);
		} else {
			if (!perDiemForTS.perDiemAmount) {
				change(`${field}.perDiemInfo.perDiemAmount`, '0');
			}
		}
		// In order to enable/disable save button after update
		change(`${field}.perDiemHasChanged`, true);
	}, [change,
		field,
		perDiemForTS,
	]);

	const changePerDiemAmount = React.useCallback((value: string) => {
		// We want to allow only numeric values
		const numericValue = value.replace(/[^\d.]/g, '');
		change(`${field}.perDiemInfo.perDiemAmount`, numericValue);
		// In order to enable/disable save button after update
		change(`${field}.perDiemHasChanged`, true);
	}, [change, field]);

	return (
		<div className={styles['user-per-diem']}>
			{isEditable ?
				<>
					<Checkbox
						handleChange={changePerDiemFlag.bind(this)}
						inline={false}
						isChecked={!!perDiemForTS.perDiemFlag}
						isDisabled={!isEditable}
						label="Per Diem"
					/>
					{perDiemForTS.perDiemFlag &&
						<div className={styles['per-diem-amount']}>
							<Field
								addonAfter="$"
								component={Input}
								format={ReduxUtils.formatDecimalNumber}
								id="amount"
								isStandalone={true}
								isZeroIfEmpty={true}
								name={`${field}.perDiemInfo.perDiemAmount`}
								onValueChange={changePerDiemAmount.bind(this)}
								type="number"
								withThousandsSeparator={true}
							/>
							<div className={styles['per-diem-amount-text']}>Amount</div>
						</div>
					}
				</>
				:
				perDiemForTS.perDiemFlag && <div className={styles['per-diem-readonly']}>
					<span className={styles['per-diem-readonly__text']}>
						PD:
					</span>
					${!!perDiemForTS.perDiemAmount ? perDiemForTS.perDiemAmount : 0}
				</div>
			}
		</div>

	);
};

export default React.memo(PerDiemOnTimeSheet);
